<template>
  <div v-if="t">
    <table
      v-if="t.interlocuteurs && t.interlocuteurs.length"
      class="table is-narrow is-fullwidth is-striped-v has-actionsontd">
      <thead class="has-cells-vcentered">
        <tr class="is-size-6">
          <th class="has-text-centered"></th>
          <th>Nom</th>
          <th>Fonction</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th class="has-text-centered">
            Utilisations
          </th>
          <th class="has-text-centered"></th>
        </tr>
      </thead>
      <tbody class="has-cells-vcentered">
        <tr
          v-for="(interlocuteur, i) in t.interlocuteurs"
          :key="interlocuteur.pk || i"
          class="is-size-6">
          <td class="has-text-centered">
            <avatar
              :item="interlocuteur"
              :i="i" />
          </td>
          <td>
            <span class="is-uppercase">{{ interlocuteur.last_name }}</span> {{ interlocuteur.first_name }}
          </td>
          <td>
            <span v-if="interlocuteur.role">{{ interlocuteur.role }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="interlocuteur.email">{{ interlocuteur.email }}</span>
            <span v-else>-</span>
          </td>
          <td class="is-nowrap">
            <phone-number
              v-if="interlocuteur.phone"
              :phone="interlocuteur.phone"></phone-number>
            <span v-else>-</span>
          </td>
          <td class="has-text-centered">
            {{ usageCount(interlocuteur) }}
          </td>
          <td class="has-text-centered">
            <display-button-list
              :buttons="buttonList"
              :data="interlocuteur">
            </display-button-list>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-else
      class="is-padding">
      <h2 class="title is-5">
        Aucun interlocuteur renseigné
      </h2>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TiersMixin from '../TiersMixin'
import { TIERS_RESOURCE } from '../tiersConstants'

export default {
  name: 'TiersInterlocuteurs',
  mixins: [TiersMixin],
  data () {
    return {
      editedInterlocuteurPk: null,
      buttonList: [
        {
          action: (id, interlocuteur) => {
            this.openInterlocuteurPanel(interlocuteur)
          },
          icon: 'fa-user-edit',
          text: 'Modifier interlocuteur'
        },
        {
          action: (id, interlocuteur) => {
            this.deleteInterlocuteur(interlocuteur)
          },
          icon: 'fa-trash-alt',
          text: 'Supprimer interlocuteur'
        }
      ]
    }
  },
  computed: {
    ...mapState(['quickview'])
  },
  watch: {
    sourceTiers (v) {
      if (v) this.initTiers({ ...v })
    },
    quickview ({ mode, params, results }) {
      if (results && mode === 'INTERLOCUTEUR_FORM' && params && params.origin === 'TiersInterlocuteurs') {
        this.saveInterlocuteur(results.interlocuteur)
      }
    }
  },
  methods: {
    /**
     * @param {object} interlocuteur
     * @returns {number}
     */
    usageCount (interlocuteur) {
      return (this.t.usages || []).filter(u => u.interlocuteur_id === interlocuteur.pk).length
    },
    /**
     * Ouvre le slide panel de création (interlocuteur null) ou d'édition
     * @param {object} interlocuteur
     */
    openInterlocuteurPanel (interlocuteur = null) {
      this.editedInterlocuteurPk = interlocuteur ? interlocuteur.pk : null
      this.$store.commit('setQuickview', {
        mode: 'INTERLOCUTEUR_FORM',
        params: {
          source: interlocuteur ? { ...interlocuteur } : {},
          origin: 'TiersInterlocuteurs'
        }
      })
    },
    /**
     * Enregistre la création/édition sur la fiche puis recharge
     * @param {object} interlocuteur
     */
    async saveInterlocuteur (interlocuteur) {
      let interlocuteurs = [...(this.t.interlocuteurs || [])]
      if (this.editedInterlocuteurPk) {
        const i = interlocuteurs.findIndex(x => x.pk === this.editedInterlocuteurPk)
        if (i >= 0) interlocuteurs.splice(i, 1, interlocuteur)
      } else {
        interlocuteurs.push(interlocuteur)
      }
      this.editedInterlocuteurPk = null
      try {
        await this.$api.patch(TIERS_RESOURCE, this.t.pk, { interlocuteurs })
        this.$toasted.global.success('Interlocuteur enregistré')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.$emit('reloadTiers', this.t.pk)
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param {object} interlocuteur
     */
    async deleteInterlocuteur (interlocuteur) {
      let value = await this.$swal({
        title: 'Suppression interlocuteur',
        text: `Êtes vous sûr de vouloir supprimer ${interlocuteur.last_name || ''} ${interlocuteur.first_name || ''} ?`,
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value.dismiss) return false
      const interlocuteurs = (this.t.interlocuteurs || []).filter(i => i.pk !== interlocuteur.pk)
      try {
        await this.$api.patch(TIERS_RESOURCE, this.t.pk, { interlocuteurs })
        this.$toasted.global.success('Interlocuteur supprimé')
        this.$emit('reloadTiers', this.t.pk)
      } catch (e) {
        if (e.response && e.response.status === 400) {
          this.$toasted.global.danger(e.response.data.message || e.response.data.exception)
        } else {
          this.$toasted.global.danger('Erreur lors de la suppression !')
        }
      }
    }
  }
}
</script>
